function init() {
    [].forEach.call(document.querySelectorAll('.js-toggle-class'), setupListeners);
}

function setupListeners(element) {
    element.addEventListener('click', () => {
        let targetSelector = element.getAttribute('data-js-target-selector');
        let targetClasses = element.getAttribute('data-js-target-classes');

        if(!targetSelector) return;

        let targets = document.querySelectorAll(targetSelector);
        [].forEach.call(targets, target => {
            target.classList.toggle(targetClasses);
        });
    });
}

module.exports = {
    init
}
